import React, { useState, useEffect } from 'react';

const PageSidebar = () => {
    const [isDevelopment, setIsDevelopment] = useState(false);

    useEffect(() => {
        // Check if running on localhost/development
        const isLocalhost = window.location.hostname === 'localhost' || 
                           window.location.hostname === '127.0.0.1' ||
                           window.location.hostname.includes('192.168.');
        
        setIsDevelopment(isLocalhost);

        // Only load Adsense script in production
        if (!isLocalhost) {
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4900533765971743';
            script.crossOrigin = 'anonymous';
            document.head.appendChild(script);

            // Initialize ads when component mounts
            script.onload = () => {
                try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                } catch (err) {
                    console.error('Adsense error:', err);
                }
            };

            return () => {
                // Cleanup if needed
                if (document.head.contains(script)) {
                    document.head.removeChild(script);
                }
            };
        }
    }, []);

    return (

        <aside id="dc-sidebar" className="dc-sidebar dc-sidebar-grid float-left mt-md-0 mt-lg-0 mt-xl-0">
            <div id="doctreat_query_online-3" className="dc-widget dc-sidebarquery dc-widget dc-onlineoptions widget_categories">
                <figure className="dc-onlinuserimg">
                    <img width="" height="" src={require('../assets/images/onlinecn.jpg')} alt="Query online" />
                    <figcaption><span>Live</span></figcaption>
                </figure>
                <div className="dc-onlineoption-content">
                    <div className="dc-title">
                        <h3><span>Stop Waiting In Queue</span>Ask Query Online</h3>
                    </div>
                    <div className="dc-btnarea">
                        <a href="#" className="dc-btn dc-btnactive">Book Audio / Video Call</a>
                    </div>
                </div>
            </div>
            <div id="doctreat_apps-5" className="dc-widget dc-sidebarapps dc-widget dc-mobileappoptions widget_categories">
                <figure className="dc-appimgs">
                    <img width="" height="" src={require('../assets/images/sidebar02.jpg')} alt="App downloads" />
                </figure>
                <div className="dc-mobileapp-content">
                    <div className="dc-title">
                        <h3>
                            <span>Care On The GO</span>								Get Mobile App							</h3>
                    </div>
                    <div className="dc-description">
                        <p>A dipisicing sed dotem eiusmou tempor incididunt ut labore</p>
                    </div>
                    <div className="dc-appemail-form">
                        <input type="email" name="app_email" value="" className="form-control" placeholder="Email ID" required="" />
                        <button type="submit" className="dc-get-app"><i className="fa fa-paper-plane"></i></button>
                    </div>
                </div>

            </div>
            <div id="doctreat_adds-5" className="dc-widget dc-sidebaradds dc-searchresultad widget_categories">
                {isDevelopment ? (
                    // Development placeholder
                    <div className="google-ads-development" style={{
                        display: 'block',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        padding: '20px',
                        textAlign: 'center',
                        borderRadius: '8px',
                        minHeight: '150px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px dashed rgba(255,255,255,0.3)'
                    }}>
                        <div style={{ fontSize: '24px', marginBottom: '10px' }}>📢</div>
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>Advertisement Space</h4>
                        <p style={{ margin: '0', fontSize: '12px', opacity: '0.8' }}>
                            Google Ads will appear here in production
                        </p>
                        <small style={{ opacity: '0.6', marginTop: '8px' }}>
                            Localhost development mode
                        </small>
                    </div>
                ) : (
                    // Production Google Ads
                    <div className="google-ads">
                        <ins 
                            className="adsbygoogle"
                            style={{display: "block"}}
                            data-ad-client="ca-pub-4900533765971743"
                            data-ad-slot="8030541670"
                            data-ad-format="auto"
                            data-full-width-responsive="true"
                            {...{"data-full-width-responsive": "true"}}
                        ></ins>
                    </div>
                )}
            </div>
        </aside>

    );
};

export default PageSidebar;
